import { motion } from "framer-motion";
import { PHASES } from "../lib/site";

const NinetyDays = () => (
    <div className="relative" data-testid="ninety-days">
        <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-ink/10 lg:block" aria-hidden="true">
            <motion.div className="h-full origin-left bg-vantera" initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true, margin: "-20% 0px" }} transition={{ duration: 2, ease: [0.16, 1, 0.3, 1] }} />
        </div>

        <div className="grid gap-12 lg:grid-cols-3 lg:gap-10">
            {PHASES.map((p, i) => (
                <motion.div key={p.days} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-12% 0px" }} transition={{ duration: 0.7, delay: i * 0.18, ease: [0.16, 1, 0.3, 1] }} className="relative border-l-2 border-vantera/40 pl-6 lg:border-0 lg:pl-0" data-testid={`ninety-days-phase-${i + 1}`}>
                    <div className="hidden lg:flex items-center gap-3">
                        <span className="relative flex size-3.5 items-center justify-center">
                            <span className="absolute size-3.5 rounded-full bg-vantera/20" />
                            <span className="relative size-2 rounded-full bg-vantera" />
                        </span>
                        <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-slategray">{p.days}</span>
                    </div>
                    <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-slategray lg:hidden">{p.days}</span>
                    <h3 className="mt-3 font-display text-3xl font-extrabold tracking-tight">{p.name}</h3>
                    <ul className="mt-6 space-y-3">
                        {p.items.map((it, j) => (
                            <li key={it} className="flex items-center gap-3 text-[16px] text-slategray">
                                <span className="inline-block size-1.5 rotate-45 bg-vantera" aria-hidden="true" />
                                {it}
                            </li>
                        ))}
                    </ul>
                </motion.div>
            ))}
        </div>
    </div>
);

export default NinetyDays;